import ModalEventBus from 'client/components/Modal/ModalEventBus';
import modalConfigs from 'client/components/Modal/LoginModalConfigs';

/**
 * This returns a nested modal payload that will open Modals in the order passed
 * @param {Array} payloads - An array of modals to be passed to the ModalEventBus
 */
export function createNestedModalPayload(payloads) {
  return payloads
    .filter(payload => payload != null)
    .reduceRight((payload, payloadItem) => ({
      ...payloadItem,
      next: payload,
    }), undefined);
}

/**
 * Maps the ModalConfigs to an array of payloads
 * @param {Array} modals - An array of object containing modal config objects
 * @returns {Array} Of the modal payloads
 */
export function getLoginModalPayloads(modals) {
  return modals.filter((modal) => {
    if (modal.showModal) {
      return modal.payload;
    }
    return null;
  });
}

/**
 * This returns an array of payloads limited to the size passed in
 * @param {Array} payloads - An array of modals to be passed to the ModalEventBus
 * @param {Number} numberOfModals - The maximum number of modals the admin should see at one time
 * Currently, numberOfModals should be limited to 2
 * @returns {Array} Of the modal payloads
 */
export function getPayloadsToDisplay(payloads, numberOfModals) {
  return payloads
    .filter(payload => payload != null)
    .slice(0, numberOfModals);
}

/**
 * @param {Array} modals An array of modals which are instances of the type LoginModal
 */
export const filterModals = (modals = []) => {
  const payloads = getLoginModalPayloads(modals);
  const payloadsToDisplay = getPayloadsToDisplay(payloads, 2);
  const nestedPayload = createNestedModalPayload(payloadsToDisplay);
  if (nestedPayload != null) {
    ModalEventBus.open(nestedPayload);
  }
};

/**
 *
 * @param {Object} params Meta-data passed from OnboardingContainer
 *  {
 *    isCommandRunner: false,
 *    isAnMsp: false,
 *    isMobile: false,
 *    onboardingFlowComplete: false,
 *    orgCreatedDate: '2020-03-23',
 *  }
 */
export function LoginModalControllerConfig(params = {}) {
  this.isCommandRunner = params.isCommandRunner;
  this.isAnMsp = params.isAnMsp;
  this.isMobile = params.isMobile;
  this.onboardingFlowComplete = params.onboardingFlowComplete;
  this.orgCreatedDate = params.orgCreatedDate;
}

/**
 * OnboardingContainer passes some basic info, such as whether the admin is a
 * command runner, the org is an MSP, the org creation date, etc.
 * to the LoginModalController
 *
 * filterModals filters the current LoginModalConfigs so that
 * at most two are shown
 *
 * If there are any modals to show, LoginModalController calls the
 * ModalEventBus.open() method to display them.
 *
 * @param {LoginModalControllerConfig} config
 * Meta-data passed from OnboardingContainer
 * @returns {Array} Array of modals
 */
export default function (config = new LoginModalControllerConfig()) {
  if (!(config instanceof LoginModalControllerConfig)) {
    throw new Error('The LoginModalController must be passed a LoginModalControllerConfig instance!');
  }
  filterModals(modalConfigs(config));
}
